<div class="sp-store-details-general__grid sp-min-height__full">
  <app-store-details-general-info
    *ngIf="!is_read_running"
    class="sp-store-details-general__info"
    [store]="store"></app-store-details-general-info>

  <app-store-details-general-ownership
    *ngIf="!is_read_running"
    [store]="store"></app-store-details-general-ownership>

  <app-store-details-general-plugin
    *ngIf="!is_read_running"
    [store]="store"></app-store-details-general-plugin>

  <app-store-details-general-settings
    class="sp-store-details-general__settings"
    *ngIf="!is_read_running"
    [store]="store"></app-store-details-general-settings>

  <app-loading
    *ngIf="is_read_running"
    class="sp-store-details-general__info sp-store-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-store-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-store-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-store-details-general__settings sp-store-details-general__loading"></app-loading>
</div>
